import { GridLegacy } from "@mui/material";
import React from "react";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper.tsx";
import FormSwitchTC from "../../../components/Forms/FormSwitchTC";
import FormControlledInputTC from "../../../components/Forms/FormControlledInputTC";
import FormAsyncTC from "../../../components/Forms/FormAsyncTC";
import { useFormContext } from "react-hook-form";

function Combinatievoordeel() {
  const { menukaartVestigingId } = useFormContext();

  return (
    <div style={{ width: "100%", height: "100%", overflow: "hidden" }}>
      <Card>
        <CardBody>
          <GridLegacy container spacing={1}>
            <FormSwitchTC
              name={"menuAvail"}
              tDefault={"Product heeft combinatie voordeel"}
              tKey={"producten.form.combinatievoordeel.label.menuAvail"}
            />
            <FormControlledInputTC
              name={"addMenuPrice"}
              rules={{
                min: {
                  value: 0,
                  message: <TranslationWrapper tKey={"The value must not be negative!"} />,
                },
              }}
              tDefault={"Menu prijs"}
              tKey={"producten.form.combinatievoordeel.label.addMenuPrice"}
              type={"currency"}
            />

            <GridLegacy item xs={12}>
              <h3>
                <TranslationWrapper tDefault={"Opties"} tKey={"producten.form.combinatievoordeel.label.opties"} />
              </h3>
            </GridLegacy>
            <FormAsyncTC
              async={{
                url:
                  "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                  menukaartVestigingId,
                searchField: "naam",
              }}
              key={"menuDrinks" + menukaartVestigingId}
              multiple={true}
              name={"menuDrinks"}
              tDefault={"Selecteer een drank"}
              tKey={"menukaarten.form.menu.taglist.menuDrinken.headerText"}
            />
            <FormAsyncTC
              async={{
                url:
                  "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                  menukaartVestigingId,
                searchField: "naam",
              }}
              key={"menuFood" + menukaartVestigingId}
              multiple={true}
              name={"menuFood"}
              tDefault={"Selecteer eten"}
              tKey={"menukaarten.form.menu.taglist.menuFood.headerText"}
            />
          </GridLegacy>
        </CardBody>
      </Card>
    </div>
  );
}

export default Combinatievoordeel;
